// @flow

import React, { Component } from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";

import type { TextareaWidget as TextareaWidgetProps } from "react-jsonschema-form/lib/components/widgets/TextareaWidget";
import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import { Text, View } from "@components";

type Props = $Exact<{
  ...TextareaWidgetProps,
  ...PropsFromLocalize,
  options: Object,
}>;

class TextareaWidget extends Component<Props> {
  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    this.props.onChange(value);
  };

  get value() {
    return this.props.value || "";
  }

  render() {
    const props = {
      ...this.props,
      ...this.props.options,
      ...(this.props.schema && this.props.schema.hasOwnProperty("minimum")
        ? { min: this.props.schema.minimum }
        : {}),
      ...(this.props.schema && this.props.schema.hasOwnProperty("maxLength")
        ? { maxLength: this.props.schema.maxLength }
        : {}),
      onChange: this.handleChange,
      value: this.value,
    };

    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;
    delete props.options;
    delete props.label;
    delete props.hidelabel;
    delete props.enumOptions;

    return (
      <React.Fragment>
        <textarea {...props} className={classNames("mt-1", "form-control", this.props.className)} />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
        {props.characterCounter && (
          <View direction="row" justifyContent="end">
            <Text>
              {props.t("CHARACTER_COUNTER", {
                available: props.maxLength - this.value.length,
              })}
            </Text>
          </View>
        )}
      </React.Fragment>
    );
  }
}

export default localize()(TextareaWidget);
